<template>
  <div role="main" class="main">
    <section class="page-header">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <ul class="breadcrumb">
              <li class="active">Kartu Peserta</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <div class="container">
      <flash-message style="position: absolute; width: 400px; top: 40px; right: 40px; z-index: 100"></flash-message>
      <div class="row">
        <div class="col-md-3">
          <sidebar/>
        </div>
        <div class="col-md-9">
          <div v-show="kartuExist" class="alert alert-info">
            Data Anda sudah terverifikasi
          </div>
          <div v-show="!kartuExist && !kartuLoading" class="alert alert-info">
            Data Anda sudah terverifikasi
          </div>
          <!-- MF, ini kalau mau aktifin pengumuman dari yudisium tinggal uncoment aja -->
          <!-- <div v-show="!$store.state.auth.isPengumuman" class="alert alert-info fade in nomargin">
            <h4>Pengumuman!</h4>
            <p>Pengumuman kelulusan untuk jalur anda adalah pada tanggal {{ $store.state.auth.date }}. </p>
          </div> -->
          <center>
            <pulse-loader style="margin: 15px" :loading="kartuLoading" color="#696969" size="10px"></pulse-loader>
          </center>
          <div class="col-md-12">
            <a v-show="!kartuExist && !kartuLoading" class="btn btn-primary" @click="checkKartu">Muat Ulang Kartu Ujian</a>
            <a v-show="kartuExist" class="btn btn-primary" :href="link" target="_blank">Download Kartu</a>
            <iframe style="margin-top: 15px"
              v-if="kartuExist"
              width="100%"
              height="500"
              :src="link"
            ></iframe>
          </div>
          <!-- <pdf v-if="kartuExist" ref="myPdfComponent" :src="link" style="width: 100%" :page="1"/> -->
          <div class="row visible-xs">
            <div class="col-md-12">
              <h4 class="heading-primary"><i class="fa fa-bullhorn"></i> Pengumuman</h4>
              <ul class="nav nav-list mb-xlg sort-source">
                <li
                  v-for="item in $store.state.pengumuman.randomThree.filter(el => el)"
                  :key="item.id"
                >
                  <a
                    @click="() => goToDetailPengumuman(item.id_pengumuman)"
                    style="cursor: pointer"
                    >{{ item.judul }}</a
                  >
                </li>
              </ul>
              <h4 class="heading-primary"><i class="fa fa-newspaper-o"></i> Artikel</h4>
              <ul class="nav nav-list mb-xlg sort-source">
                <li
                  v-for="item in $store.state.artikel.randomThree.filter(el => el)"
                  :key="item.id"
                >
                  <a
                    @click="() => goToDetailArtikel(item.id_berita)"
                    style="cursor: pointer"
                  >
                    {{ item.judul }}</a
                  >
                </li>
                <li>
                  <a @click="() => goToCardArtikel()" style="cursor: pointer">
                    <h6 class="heading-primary">
                      Selengkapnya...
                    </h6>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/Sidebar'
import Pdf from 'vue-pdf'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { base } from '@/api/data'
import api from '@/api'

export default {
  data () {
    return {
      kartuLoading: false,
      kartuExist: false,
      link: ''
    }
  },
  mounted () {
    this.checkKartu()
    this.$store.dispatch('getStatusLoa', {nomor_peserta: this.$store.getters.getAuthData.data.no_peserta})
    this.$store.dispatch('getStatusLoaConditional', {nomor_peserta: this.$store.getters.getAuthData.data.no_peserta})
  },
  computed: {
    nomorPeserta () {
      return this.$store.getters.getVerificationData.nomorPeserta
    }
  },
  components: {
    'sidebar': Sidebar,
    'pdf': Pdf,
    'pulse-loader': PulseLoader
  },
  methods: {
    checkKartu () {
      this.kartuLoading = true
      api.get('/v2/kartu_ujian/cek/' + this.nomorPeserta)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            this.kartuLoading = false
            this.kartuExist = true
            this.link = base + 'storage/download/kartu/kartu_ujian_' + this.nomorPeserta + '.pdf'
          }
        })
        .catch(e => {
          if (e.response.status === 429) {
            this.flash('Mohon maaf server tidak dapat merespon dengan baik', 'error', {timeout: 3000})
          }
          // FIXME: Tell our user when we got some errors
          console.log(e)
          this.kartuLoading = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/register/Kartu.vue